import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import 'antd/dist/reset.css';
import "./styles/index.scss"
import {notificationSucces} from "./services/notification";
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
import Loading from './components/UI/Loading';

//const isProduction = process.env.NODE_ENV === 'production';
const isProduction = true;

ReactDOM.createRoot(document.getElementById('root')!).render(
        <CacheBuster
            currentVersion={version}
            isEnabled={isProduction} //If false, the library is disabled
            isVerboseMode={true} //If true, the library writes verbose logs to console
            loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check
            metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server
        >
            <App />
        </CacheBuster>
)
